import useFetch from '@hooks/useFetch';
import { emptyObject } from '@constants/empty';
import { useRouter } from 'next/router';
import { getCompeteRatingKey } from '@cont/Compete/utils';
import { HOST_TYPE } from '@utils/api-helper/host';

const useRatingInfo = (
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const { query } = useRouter();

  const key = getCompeteRatingKey(query.goalUID);

  const { data, isValidating, mutate, ...rest } = useFetch(
    key,
    { hostType: HOST_TYPE.CMS },
    {
      revalidateOnMount: true,
      fallbackData: options.fallbackData
    }
  );

  return {
    key,
    levels: data?.levels || emptyObject,
    isValidating,
    mutate,
    ...rest
  };
};

export default useRatingInfo;
